import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import ShareIcon from "../../assets/images/share.png";
import { getSettingByKey } from "../common";
import { CustomSnackbar } from "../CustomSnackbar";
import styles from "../Common/StickyWhatsApp/styles.module.css"; // Refactored to dedicated CSS module

const StickyShare = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const settings = useSelector((state) => state.settings.data);

  const companyWhatsappNumber = getSettingByKey(
    settings,
    "company_whatsapp_number"
  )?.value;

  if (!companyWhatsappNumber) {
    return null;
  }



  // Dynamic values to prevent ESLint 'no-undef' errors
  const currentUrl = typeof window !== "undefined" ? window.location.href : "";
  const shareMessage = "Check out this page!";

  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: document.title,
          text: shareMessage,
          url: currentUrl,
        });
        setMenuOpen(false);
        return true;
      } catch (err) {
        if (err.name !== "AbortError") {
          console.error("Error sharing:", err);
        }
      }
    }
    return false;
  };

  const handleWhatsAppShare = async () => {
    const url = `https://wa.me/?text=${encodeURIComponent(
      `${shareMessage} ${currentUrl}`
    )}`;
    window.open(url, "_blank", "noopener,noreferrer");
    setMenuOpen(false);
  };

  const handleFacebookShare = () => {
    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      currentUrl
    )}&quote=${encodeURIComponent(shareMessage)}`;
    window.open(url, "_blank", "noopener,noreferrer");
    setMenuOpen(false);
  };

  const handleInstagramShare = async () => {
    try {
      await navigator.clipboard.writeText(`${shareMessage} ${currentUrl}`);
      if (typeof CustomSnackbar !== "undefined" && CustomSnackbar.success) {
        CustomSnackbar.success("Message copied! Paste it in Instagram.");
      }
    } catch (err) {
      console.error("Failed to copy share message:", err);
    }
    window.open("https://www.instagram.com/", "_blank", "noopener,noreferrer");
    setMenuOpen(false);
  };

  const handleToggleClick = async () => {
    // Uses native share tray on mobile devices if supported
    const sharedNatively = await handleNativeShare();
    if (!sharedNatively) {
      setMenuOpen((prev) => !prev);
    }
  };

  return (
    <div
      className={styles.stickyShareWrapper}
      onMouseEnter={() => setMenuOpen(true)}
      onMouseLeave={() => setMenuOpen(false)}
    >
      {/* Share Actions Menu */}
      <div
        className={`${styles.shareMenu} ${menuOpen ? styles.show : ""}`}
        role="menu"
        aria-hidden={!menuOpen}
      >
        <button
          type="button"
          className={styles.shareMenuItem}
          onClick={handleWhatsAppShare}
          aria-label="Share on WhatsApp"
          data-tooltip="WhatsApp"
        >
          <Icon icon="mdi:whatsapp" fontSize={20} color="#25D366" />
        </button>

        <button
          type="button"
          className={styles.shareMenuItem}
          onClick={handleFacebookShare}
          aria-label="Share on Facebook"
          data-tooltip="Facebook"
        >
          <Icon icon="mdi:facebook" fontSize={20} color="#1877F2" />
        </button>

        <button
          type="button"
          className={styles.shareMenuItem}
          onClick={handleInstagramShare}
          aria-label="Share on Instagram"
          data-tooltip="Instagram"
        >
          <Icon icon="mdi:instagram" fontSize={20} color="#E1306C" />
        </button>
      </div>

      {/* Trigger Button */}
      <button
        type="button"
        className={`${styles.shareToggleBtn} ${menuOpen ? styles.active : ""}`}
        onClick={handleToggleClick}
        aria-expanded={menuOpen}
        aria-label="Share options"
      >
        {ShareIcon ? (
          <img src={ShareIcon} alt="Share" className={styles.shareImgIcon} />
        ) : (
          <Icon icon="mdi:share-variant" fontSize={22} color="#ffffff" />
        )}
      </button>
    </div>
  );
};

export default StickyShare;